import React from 'react'

import { Grid as GridBase, styled } from '@mui/material'
import { Add as AddBase, ArrowBack as ArrowBackBase, CheckCircle as CheckCircleBase } from '@mui/icons-material'

import { Button as ButtonBase, TableRow as TableRowBase } from '@chilecompra/react-kit/components'

export const Root = styled('div')`
  width: 100%;
`

export const GridContainer = styled(({ margin, padding, ...props }) => <GridBase container {...props} />)`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(({ margin, overflowX, padding, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    overflow-x: ${props => props.overflowX};
    padding: ${props => props.padding};
  }
`

export const BackLink = styled('div')`
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  text-decoration: none;

  &:hover .MuiSvgIcon-root {
    fill: ${props => props.theme.palette.brand.black2};
  }

  &:hover span {
    color: ${props => props.theme.palette.brand.black2};
    text-decoration: underline;
  }
`

export const BackIcon = styled(ArrowBackBase)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.brand.black3};
  }
`

export const BackText = styled('span')`
  color: ${props => props.theme.palette.brand.black3};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  letter-spacing: 0;
  line-height: 20px;
  margin: 0 0 0 5px;
  user-select: none;
`

export const Title = styled('h2')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 27px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 31px;
  margin: 0;
`

export const Description = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  letter-spacing: 0;
  line-height: 20px;
  margin: 0;
`

export const Form = styled('form')``

export const CardImage = styled('img')`
  width: 82px;
`

export const CardTitle = styled('h2')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 22px;
  margin: 0;
`

export const CardDescription = styled('p')`
  color: ${props => props.theme.palette.brand.black3};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  letter-spacing: 0;
  line-height: 18px;
  margin: 0;
  max-width: 350px;
`

export const Results = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 23px;
  margin: 0;
`

export const TableRow = styled(({ active, ...props }) => <TableRowBase {...props} />)`
  &.MuiTableRow-root {
    background-color: ${props => (props.active ? props.theme.palette.green[95] : 'transparent')};
  }
`

export const RecordText = styled('span')`
  color: ${props => props.theme.palette.brand.black3};
`

export const Action = styled(({ active, ...props }) => <div {...props} />)`
  align-items: center;
  display: inline-flex;
  cursor: ${props => (props.active ? 'initial' : 'pointer')};

  &:hover > span:first-of-type {
    text-decoration: ${props => (props.active ? 'none' : 'underline')};
  }
`

export const ActionIcon = styled(({ active, ...props }) =>
  active ? <CheckCircleBase {...props} /> : <AddBase {...props} />
)`
  &.MuiSvgIcon-root {
    fill: ${props => (props.active ? props.theme.palette.brand.success : props.theme.palette.brand.primary)};
    font-size: 1.3rem;
  }
`

export const ActionText = styled(({ active, ...props }) => <span {...props} />)`
  color: ${props => (props.active ? props.theme.palette.brand.success : props.theme.palette.brand.primary)};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  letter-spacing: 0;
  line-height: 25px;
  margin: 0 0 0 5px;
`

export const ActionDelete = styled('span')`
  color: ${props => props.theme.palette.brand.black3};
  cursor: pointer;
  font-family: Roboto;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 25px;
  margin: 0 0 0 37px;
  text-decoration: underline;

  &:hover {
    color: ${props => props.theme.palette.brand.black2};
  }
`

export const BackButton = styled(ButtonBase)`
  &.MuiButtonBase-root:hover .MuiSvgIcon-root {
    fill: ${props => props.theme.palette.brand.white};
  }
`
